"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeadingTag = exports.HeadingElement = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _excluded = ["heading"];
var StyledHeadingTag = exports.StyledHeadingTag = _styledComponents["default"].h2.withConfig({
  displayName: "HeadingElement__StyledHeadingTag",
  componentId: "sc-1fqxeih-0"
})(["margin:0;"]);
var HeadingElement = exports.HeadingElement = /*#__PURE__*/_react["default"].forwardRef(function Heading(_ref, ref) {
  var heading = _ref.heading,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHeadingTag, Object.assign({
    as: heading
  }, props, {
    ref: ref
  }));
});